module.exports = __webpack_public_path__ + "static/media/telegram.c4c99031.svg";